module.exports = __webpack_public_path__ + "img/Quallen.3be51b2b.jpg";